module.exports = __webpack_public_path__ + "img/comp-card-btn.b0d25115.svg";